export default function CurrentOverview() {
  const updates = [
    {
      badge: 'NEW',
      title: 'Mawariネットワーク最新アップデート',
      date: '2026年1月15日',
      description: 'ノードのパフォーマンスが向上し、報酬計算システムが最適化されました。',
      image: 'https://public.readdy.ai/ai/img_res/1b39d31673c37b01172d503435f0d830.jpg',
    },
    {
      title: 'ロッキング期間延長のお知らせ',
      date: '2026年1月10日',
      description: '新しいロッキングオプションが追加され、より柔軟な運用が可能になりました。',
      image: 'https://readdy.ai/api/search-image?query=Digital%20lock%20icon%20with%20glowing%20effect%20futuristic%20security%20concept%20soft%20pink%20and%20purple%20ambient%20light%20clean%20white%20background%20modern%20minimal%20style&width=600&height=400&seq=update-002&orientation=landscape',
    },
    {
      title: 'コミュニティイベント開催決定',
      date: '2026年1月5日',
      description: 'Mawariノードオーナー限定のオンラインミートアップを開催します。',
      image: 'https://readdy.ai/api/search-image?query=Diverse%20group%20of%20people%20connecting%20online%20through%20holographic%20screens%20friendly%20community%20atmosphere%20soft%20pastel%20colors%20modern%20digital%20meeting%20space%20warm%20lighting&width=600&height=400&seq=update-003&orientation=landscape',
    },
  ];

  return (
    <section id="overview" className="py-24 px-6 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-5xl font-bold text-gray-900 mb-4">
            今のMawariがひと目でわかる
          </h2>
          <p className="text-xl text-gray-600">
            最新のアップデートとお知らせをチェック
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {updates.map((update, index) => (
            <div
              key={index}
              className="group bg-white rounded-3xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 hover:scale-105 border border-gray-100 cursor-pointer"
            >
              <div className="relative w-full h-64">
                <img
                  src={update.image}
                  alt={update.title}
                  className="w-full h-full object-cover object-top"
                />
                {update.badge && (
                  <div className="absolute top-4 left-4 px-4 py-2 bg-gradient-to-r from-pink-500 to-purple-500 text-white text-sm font-bold rounded-full">
                    {update.badge}
                  </div>
                )}
              </div>
              <div className="p-8">
                <p className="text-sm text-gray-500 mb-3">{update.date}</p>
                <h3 className="text-2xl font-bold text-gray-900 mb-4 leading-tight">
                  {update.title}
                </h3>
                <p className="text-lg text-gray-600 leading-relaxed">
                  {update.description}
                </p>
                <div className="mt-6 flex items-center text-pink-500 font-semibold text-lg">
                  続きを読む
                  <i className="ri-arrow-right-line ml-2 group-hover:translate-x-2 transition-transform"></i>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}